/* Component Dependencies */
var equipmentAndServicesTemplate = require('templates/equipmentAndServices.hbs');
var equipmentAndServicesBusinessTemplate = require('templates/equipmentAndServices-business.hbs');
var equipmentAndServicesGroupSearchTemplate = require('templates/equipmentAndServices-groupSearch.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'equipmentAndServices',
  template: {
    'equipmentAndServices': equipmentAndServicesTemplate,
    'equipmentAndServices-business': equipmentAndServicesBusinessTemplate,
    'equipmentAndServices-groupSearch': equipmentAndServicesGroupSearchTemplate
  }
});
